// Saisonphasen an EINER Stelle.
//
// Vertrag (docs/DATENMODELL.md):
// - `seasonType` in `spiele` kommt direkt von ESPN: 2 = Regular Season,
//   3 = Playoffs. Das ist die Quelle für die Phase, nicht die Wochennummer.
// - `playoffRunde` ('wildCard' | 'divisional' | 'conference' | 'superBowl')
//   schreibt der Import zusätzlich in jedes Playoff-Doc. Die Wochennummer
//   eines Playoff-Spiels ist "letzte Regular-Season-Woche + Runde" und dient
//   nur Sortierung und Anzeige. Bei 18 Regular-Season-Wochen sind das die
//   gewohnten 19–22; verlängert die NFL auf 19 Wochen, werden es 20–23,
//   ohne dass Punkteregeln oder Anzeige angepasst werden müssen.
// - Ältere Docs ohne `playoffRunde` werden über die Wochen 19–22 erkannt.

export const PLAYOFF_RUNDEN = ['wildCard', 'divisional', 'conference', 'superBowl'];

export const PLAYOFF_RUNDEN_NAMEN = {
  wildCard: 'Wild Card',
  divisional: 'Divisional',
  conference: 'Conference',
  superBowl: 'Super Bowl'
};

// ESPN nummeriert Playoff-Wochen 1, 2, 3, 5 (4 = Pro Bowl, wird gefiltert)
export const ESPN_PLAYOFF_WOCHE_ZU_RUNDE = {
  1: 'wildCard',
  2: 'divisional',
  3: 'conference',
  5: 'superBowl'
};

// Nur für Docs ohne playoffRunde (Importe vor September 2026)
const LEGACY_WOCHE_ZU_RUNDE = { 19: 'wildCard', 20: 'divisional', 21: 'conference', 22: 'superBowl' };

// Virtuelle "Woche" für Bonusfragen in Ranking-Charts (kein Spiel-Doc)
export const BONUSFRAGEN_WEEK = 23;

export const istPlayoffSpiel = (spiel) => {
  if (!spiel) return false;
  if (spiel.playoffRunde) return true;
  if (spiel.seasonType !== undefined && spiel.seasonType !== null) {
    return Number(spiel.seasonType) === 3;
  }
  return Number(spiel.week) >= 19;
};

export const istRegularSeasonSpiel = (spiel) => !istPlayoffSpiel(spiel);

// Runde eines Playoff-Spiels ('wildCard' …) oder null
export const playoffRunde = (spiel) => {
  if (!spiel) return null;
  if (spiel.playoffRunde) return spiel.playoffRunde;
  if (!istPlayoffSpiel(spiel)) return null;
  return LEGACY_WOCHE_ZU_RUNDE[Number(spiel.week)] || null;
};

// Wochennummer für ein Playoff-Spiel: letzte Regular-Season-Woche + Runde
export const playoffWoche = (regularWochen, runde) => {
  const index = PLAYOFF_RUNDEN.indexOf(runde);
  return index >= 0 ? regularWochen + index + 1 : null;
};

// Anzahl Regular-Season-Wochen aus den vorhandenen Playoff-Wochen ableiten:
// die erste Playoff-Woche minus eins. Ohne Playoff-Docs (Saisonstart) 18.
export const regularSeasonWochen = (playoffWochen = []) => {
  const wochen = playoffWochen.map(Number).filter(w => w > 0);
  return wochen.length > 0 ? Math.min(...wochen) - 1 : 18;
};

// Anzeigename einer Woche. `playoffWochen` sind die in dieser Saison
// vorhandenen Playoff-Wochennummern (aufsteigend); ihre Position bestimmt
// die Runde. Ohne Angabe gilt das Standard-Schema 19–22.
export const wocheName = (week, playoffWochen = [19, 20, 21, 22]) => {
  const w = Number(week);
  if (w === BONUSFRAGEN_WEEK && !playoffWochen.includes(w)) return 'Bonusfragen';
  const index = playoffWochen.indexOf(w);
  if (index >= 0 && PLAYOFF_RUNDEN[index]) return PLAYOFF_RUNDEN_NAMEN[PLAYOFF_RUNDEN[index]];
  return `Week ${w}`;
};

// Kurzform für enge Stellen (Achsen, Chips)
export const wocheKurz = (week, playoffWochen = [19, 20, 21, 22]) => {
  const w = Number(week);
  if (w === BONUSFRAGEN_WEEK && !playoffWochen.includes(w)) return 'Bonus';
  const kurz = { wildCard: 'WC', divisional: 'DIV', conference: 'CONF', superBowl: 'SB' };
  const index = playoffWochen.indexOf(w);
  if (index >= 0 && PLAYOFF_RUNDEN[index]) return kurz[PLAYOFF_RUNDEN[index]];
  return String(w);
};
